import React from "react";
import MyAreaChart from "../MyAreaChart/MyAreaChart";
import MyLineChart from "../MyLineChart/MyLineChart";
import "./Dashboard.css";

const Dashboard = () => {
  const data = [
    {
      month: "Mar",
      investment: 100000,
      sell: 241,
      revenue: 104010,
    },
    {
      month: "Apr",
      investment: 200000,
      sell: 423,
      revenue: 245000,
    },
    {
      month: "May",
      investment: 500000,
      sell: 726,
      revenue: 670100,
    },
    {
      month: "Jun",
      investment: 500000,
      sell: 529,
      revenue: 404050,
    },
    {
      month: "Jul",
      investment: 600000,
      sell: 601,
      revenue: 509000,
    },
    {
      month: "Aug",
      investment: 700000,
      sell: 670,
      revenue: 610000,
    },
  ];
  return (
    <div className="dashboard-container">
      <MyLineChart data={data}></MyLineChart>

      <MyAreaChart data={data}></MyAreaChart>
    </div>
  );
};

export default Dashboard;
